import { LocalizedTextDisplayModel } from '@/api/models/ace/xFound/Portal/Core/CAQ/Models/localized-text-display-model';
import { AnfrageListDisplayModel } from '@/api/models/ace/xFound/Portal/Core/CAQ/Models/anfrage-list-display-model';
import { PortalkonfigurationDisplayModel } from '@/api/models/ace/xFound/Portal/Core/CAQ/Models/portalkonfiguration-display-model';
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { I18nService } from '@/core/services/i18nService';

@Component({
    selector: 'anfrage-overview',
    templateUrl: './anfrage-overview.component.html',
    styleUrls: ['./anfrage-overview.component.scss']
})
export class AnfrageOverviewComponent implements OnInit {
    public portalkonfiguration: PortalkonfigurationDisplayModel;
    public anfragen: AnfrageListDisplayModel[];

    constructor(protected router: Router, protected route: ActivatedRoute, protected languageservice: I18nService) {
        //
    }

    ngOnInit(): void {
        this.portalkonfiguration = this.route.snapshot.data.portalkonfiguration;
        this.anfragen = this.route.snapshot.data.anfragen;
    }

    public get showList(): boolean {
        return this.anfragen?.length > 0;
    }

    public get title(): string {
        let title: LocalizedTextDisplayModel | undefined = this.languageservice.getCurrentLocalizedTextDisplayModel(this.portalkonfiguration.willkommenstexte);
        return title?.text ?? "";
    }

    public get subtitle(): string {
        let subtitle: LocalizedTextDisplayModel | undefined = this.languageservice.getCurrentLocalizedTextDisplayModel(this.portalkonfiguration.infotexteMeineProjektideen)
        return subtitle?.text ?? "";
    }

    public onAnfrageDelete(projekt: AnfrageListDisplayModel) {
        this.anfragen = this.anfragen.filter(item => item.nummer != projekt.nummer);
    }
}